import React from 'react';
const SvgCloudUpload: React.FC<React.SVGProps<SVGSVGElement>> = (
  props: React.SVGProps<SVGSVGElement>,
) => {
  return (
    <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g strokeLinecap="round" strokeLinejoin="round">
        <path d="M6.324 9.068C3.885 9.401 2 11.47 2 14a5 5 0 005 5h11a4 4 0 000-8A5.997 5.997 0 006.324 9.068z" />
        <path d="M9.833 12.667L12 10.5l2.167 2.167M12 15.5v-5" />
      </g>
    </svg>
  );
};
export default SvgCloudUpload;
